// extracted by mini-css-extract-plugin
export default {"mainContainer":"ImageText_mainContainer__6XkQG","heading":"ImageText_heading__iDnrR","content":"ImageText_content__CMrH-","line":"ImageText_line__CbS-h"};